export default {
    namespaced: true,
    state: () => ({

        discrepancyFilters:{
            location:'',
            supplier:'',
            date_from:'',
            date_to:'',

        },

    }),
    mutations: {

        setDiscrepancyFilters(state, data) {
            state.discrepancyFilters = { ...state.discrepancyFilters, ...data };
        },


    },
    actions: {

        updateDiscrepancyFilters({ commit }, filters) {
            commit('setDiscrepancyFilters', filters);
        },

    },


}
